
// import React, { useState } from "react";
// import { Box, Radio, RadioGroup, FormControlLabel } from "@mui/material";
// import BusinessWms from "../../businessPageData/businessWms/BusinessWms";
// import BusinessInnerChart1 from "./BusinessInnerChart1";
// import BusinessInnerChart2 from "./BusinessInnerChart2";
// import BusinessInnerChart3 from "./BusinessInnerChart3";
// import BusinessInnerChart4 from "./BusinessInnerChart4";

// export default function BusinessInnerChart() {
//   const [selectedTab, setSelectedTab] = useState("Monthly Yield");

//   const handleChange = (event) => {
//     setSelectedTab(event.target.value);
//   };

//   return (
//     <Box sx={{ width: "100%",height:"100%" }}>
//       {/* Radio Tabs Header */}
//       <RadioGroup
//         row
//         value={selectedTab}
//         onChange={handleChange}
//         sx={{ justifyContent: "start", mb: 2 }}
//       >
//         <FormControlLabel
//           value="Monthly Yield"
//           control={<Radio size="small" />}
//           label="Todays KWh Vs. Todays CUF "
//         />
//         <FormControlLabel
//           value="Today"
//           control={<Radio size="small" />}
//           label="Todays KWh Vs. Todays PR"
//         />
//         <FormControlLabel
//           value="Plant Cumulative"
//           control={<Radio size="small" />}
//           label="Todays PR Vs. Todays CUF"
//         />
//         <FormControlLabel
//           value="Todays Specific Yield"
//           control={<Radio size="small" />}
//           label="Todays Specific Yield"
//         />
//       </RadioGroup>

//       {/* Tab Content */}
//       <Box sx={{ mt: 2 }}>
//         {selectedTab === "Monthly Yield" && <BusinessInnerChart1/>}
//         {selectedTab === "Today" && <BusinessInnerChart2 />}
//         {selectedTab === "Plant Cumulative" && <BusinessInnerChart3/>}
//         {selectedTab === "Todays Specific Yield" && <BusinessInnerChart4/>}
//       </Box>
//     </Box>
//   );
// }


import React, { useRef, useState } from "react";
import { Box, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import DownloadJpegButton from "../../../../../components/downloadJpegButton/DownloadJpegButton"; 
import BusinessInnerChart1 from "./BusinessInnerChart1";
import BusinessInnerChart2 from "./BusinessInnerChart2";
import BusinessInnerChart3 from "./BusinessInnerChart3";
import BusinessInnerChart4 from "./BusinessInnerChart4";

// export default function BusinessInnerChart({ onFullScreen }) {
//   const [selectedTab, setSelectedTab] = useState("Monthly Yield");

//   // Create refs for each chart
//   const chart1Ref = useRef();
//   const chart2Ref = useRef();
//   const chart3Ref = useRef();
//   const chart4Ref = useRef();

//   const handleChange = (event) => {
//     setSelectedTab(event.target.value);
//   };

//   // Determine which chart ref is active
//   const activeRef =
//     selectedTab === "Monthly Yield"
//       ? chart1Ref
//       : selectedTab === "Today"
//       ? chart2Ref
//       : selectedTab === "Plant Cumulative"
//       ? chart3Ref
//       : chart4Ref;

//   return (
//     <Box sx={{ width: "100%", height: "100%" }}>
//       {/* Radio Tabs Header */}
//       <RadioGroup
//         row
//         value={selectedTab}
//         onChange={handleChange}
//         sx={{ justifyContent: "start", mb: 2 }}
//       >
//         <FormControlLabel
//           value="Monthly Yield"
//           control={<Radio size="small" />}
//           label="Todays KWh Vs. Todays CUF"
//         />
//         <FormControlLabel
//           value="Today"
//           control={<Radio size="small" />}
//           label="Todays KWh Vs. Todays PR"
//         />
//         <FormControlLabel
//           value="Plant Cumulative"
//           control={<Radio size="small" />}
//           label="Todays PR Vs. Todays CUF"
//         />
//         <FormControlLabel
//           value="Todays Specific Yield"
//           control={<Radio size="small" />}
//           label="Todays Specific Yield"
//         />
//       </RadioGroup>

//       {/* Download Button */}
//       <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
//         <DownloadJpegButton
//           targetRef={activeRef}
//           fileName={`${selectedTab.replace(/\s+/g, "")}.jpeg`}
//         />
//       </Box>

//       {/* Chart Content */}
//       <Box sx={{ mt: 2 }}>
//         {selectedTab === "Monthly Yield" && (
//           <div ref={chart1Ref}>
//             <BusinessInnerChart1 />
//           </div>
//         )}
//         {selectedTab === "Today" && (
//           <div ref={chart2Ref}>
//             <BusinessInnerChart2 />
//           </div>
//         )}
//         {selectedTab === "Plant Cumulative" && (
//           <div ref={chart3Ref}>
//             <BusinessInnerChart3 />
//           </div>
//         )}
//         {selectedTab === "Todays Specific Yield" && (
//           <div ref={chart4Ref}>
//             <BusinessInnerChart4 />
//           </div>
//         )}
//       </Box>
//     </Box>
//   );
// }


export default function BusinessInnerChart({ onFullScreen }) {
  // Set default tab to first label
  const [selectedTab, setSelectedTab] = useState("Todays KWh Vs. Todays CUF");

  // Create refs for each chart
  const chart1Ref = useRef();
  const chart2Ref = useRef();
  const chart3Ref = useRef();
  const chart4Ref = useRef();

  const handleChange = (event) => {
    setSelectedTab(event.target.value);
  };

  // Determine which chart ref is active
  const activeRef =
    selectedTab === "Todays KWh Vs. Todays CUF"
      ? chart1Ref
      : selectedTab === "Todays KWh Vs. Todays PR"
      ? chart2Ref
      : selectedTab === "Todays PR Vs. Todays CUF"
      ? chart3Ref
      : chart4Ref;

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      {/* Radio Tabs Header */}
      <RadioGroup
        row
        value={selectedTab}
        onChange={handleChange}
        sx={{ justifyContent: "start", mb: 2 }}
      >
        <FormControlLabel
          value="Todays KWh Vs. Todays CUF"
          control={<Radio size="small" />}
          label="Todays KWh Vs. Todays CUF"
        />
        <FormControlLabel
          value="Todays KWh Vs. Todays PR"
          control={<Radio size="small" />}
          label="Todays KWh Vs. Todays PR"
        />
        <FormControlLabel
          value="Todays PR Vs. Todays CUF"
          control={<Radio size="small" />}
          label="Todays PR Vs. Todays CUF"
        />
        <FormControlLabel
          value="Todays Specific Yield"
          control={<Radio size="small" />}
          label="Todays Specific Yield"
        />
      </RadioGroup>

      {/* Download Button */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <DownloadJpegButton
          targetRef={activeRef}
          fileName={`${selectedTab.replace(/\s+/g, "_")}.jpeg`}
        />
      </Box>

      {/* Chart Content */}
      <Box sx={{ mt: 2 }}>
        {selectedTab === "Todays KWh Vs. Todays CUF" && (
          <div ref={chart1Ref}>
            <BusinessInnerChart1 />
          </div>
        )}
        {selectedTab === "Todays KWh Vs. Todays PR" && (
          <div ref={chart2Ref}>
            <BusinessInnerChart2 />
          </div>
        )}
        {selectedTab === "Todays PR Vs. Todays CUF" && (
          <div ref={chart3Ref}>
            <BusinessInnerChart3 />
          </div>
        )}
        {selectedTab === "Todays Specific Yield" && (
          <div ref={chart4Ref}>
            <BusinessInnerChart4 />
          </div>
        )}
      </Box>
    </Box>
  );
}

